import React from 'react'

import { publishEvent } from '@zet/analytics'
import { MotiView } from '@zet/common/components/motiView'
import { B4, B5, colors, H5, SH1, Stack, XStack } from '@zet/design-system'
import { Alert } from '@zet/design-system/alert'
import { RupeeGreenFilled } from '@zet/feature-earnings/assests/svg'
import { i18n } from '@zet/localization'
import { currencyFormatConvertor } from '@zet/utils/stringConversion'
import { Skeleton } from 'moti/skeleton'

import { i18n as _i18n } from '../../localization'
import { useNavigation } from '../../utils/navigation'

type Props = {
  totalEarnings: number | null | undefined
  fetching: boolean
}

const TotalEarningsSection = ({ totalEarnings, fetching = false }: Props) => {
  const amount = totalEarnings ? parseFloat(totalEarnings.toFixed(2)) : 0

  const { navigate } = useNavigation()
  const handlePress = () => {
    navigate('TDS')
    publishEvent('click_action', {
      item_name: 'home_page_earnings_know_more',
    })
  }
  return (
    <Stack className="border-grays-40 border-b px-3 pb-2">
      <XStack className=" items-center">
        <RupeeGreenFilled />
        <Stack className="ml-3">
          <SH1 className="text-grays-60 -mb-1">
            {_i18n.t('earningsList.yourEarnings')}
          </SH1>
          {fetching ? (
            <Stack className="pt-1">
              <MotiView
                className="flex-row justify-between"
                transition={{
                  type: 'timing',
                }}
                animate={{ backgroundColor: colors.neutral.white100 }}
              >
                <Skeleton
                  colorMode={'light'}
                  width={100}
                  height={27}
                  radius={4}
                />
              </MotiView>
            </Stack>
          ) : !isNaN(amount) ? (
            <H5>₹{currencyFormatConvertor(amount.toString())}</H5>
          ) : (
            <></>
          )}
        </Stack>
      </XStack>
      <Alert intent="warning" className="mb-2 mt-3">
        {amount && amount >= 1 && amount && amount < 6 ? (
          <B5>{i18n.t('minimumAmountRequired')}</B5>
        ) : (
          <B5>
            {i18n.t('earnings.tdsNote')}
            <B4
              className="text-primary-100 active:text-grays-40"
              onPress={handlePress}
            >
              {` ${i18n.t('knowMore')}`}
            </B4>
          </B5>
        )}
      </Alert>
    </Stack>
  )
}

export default TotalEarningsSection
